/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { Skeleton } from '@material-ui/lab';
import { Button, Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  cardPreview: {
    display: 'inline-block',
    marginRight: '2rem',
    marginBottom: '2rem',
  },
}));

export default function LoadingPreview() {
  const classes = useStyles();
  return (
    <>
      <br />
      <Skeleton>
        <Typography variant="h1">Lorem ipsum dolor</Typography>
      </Skeleton>
      <Divider />
      <Skeleton>
        <Typography variant="h1">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent neque nisi.
        </Typography>
      </Skeleton>
      <Skeleton width={300} height={60} />
      <Skeleton width={400} height={120} />
      <br />
      <br />
      <Skeleton>
        <Typography variant="h1">Parties</Typography>
      </Skeleton>
      <Divider />
      <Skeleton>
        <Typography variant="h1">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Typography>
      </Skeleton>
      <Skeleton>
        <Typography variant="h2">Lorem ipsum dolor</Typography>
      </Skeleton>
      <Skeleton>
        <Button>Lorem ipsum</Button>
      </Skeleton>
      <br />
      <div>
        <div className={classes.cardPreview}>
          <Skeleton variant="rect" height={230} width={300} />
        </div>
        <div className={classes.cardPreview}>
          <Skeleton variant="rect" height={230} width={300} />
        </div>
      </div>
      <br />
      <Skeleton>
        <Typography variant="h2">Lorem ipsum dolor</Typography>
      </Skeleton>
      <Skeleton>
        <Button>Lorem ipsum</Button>
      </Skeleton>
      <br />
      <Skeleton>
        <Typography variant="h2">Lorem ipsum dolor</Typography>
      </Skeleton>
      <Skeleton>
        <Button>Lorem ipsum</Button>
      </Skeleton>
    </>
  );
}
